import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader } from "@/components/ui/alert-dialog";
import { AlertDialogTitle } from "@radix-ui/react-alert-dialog";
import { useMatterJurisdiction } from "@/components/contexts/MatterJurisdictionContext";

type DeleteAlertDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  isDeleting: boolean;
  onDelete: () => void;
}

export const DeleteAlertDialog = ({ open, onOpenChange, title, isDeleting, onDelete }: DeleteAlertDialogProps) => {
  const { ui_labels } = useMatterJurisdiction().jurisdiction;
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent
        onClick={(e) => e.stopPropagation()}
        onPointerDown={(e) => e.stopPropagation()}
      >
        <AlertDialogHeader>
          <AlertDialogTitle>{ui_labels.bundle_delete_title}</AlertDialogTitle>
          <AlertDialogDescription>
            This will delete the {ui_labels.bundle_singular.toLowerCase()} &quot;{title}&quot;.
            Documents in your case files will not be deleted.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting}>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onDelete} disabled={isDeleting} className="bg-red-600 hover:bg-red-700 focus:ring-red-600 text-white">
            {isDeleting ? 'Deleting...' : 'Delete'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
